import { QuadrantLabel } from "@/Components/v2/molecule/BubbleChart/types";
import { LIKELIHOOD_LEVELS } from "../likelihood";

const quadrantLabelOptions: QuadrantLabel[] = [
  {
    position: "top-left",
    title: "Moderate Likelihood",
    titleColor: LIKELIHOOD_LEVELS.MODERATE.color,
    descriptions: ["Large Change from Historic", "Small Confidence Interval"],
  },
  {
    position: "top-right",
    title: "Low Likelihood",
    titleColor: LIKELIHOOD_LEVELS.LOW.color,
    descriptions: ["Large Change from Historic", "Large Confidence Interval"],
  },
  {
    position: "bottom-left",
    title: "High Likelihood",
    titleColor: LIKELIHOOD_LEVELS.HIGH.color,
    descriptions: ["Small Change from Historic", "Small Confidence Interval"],
  },
  {
    position: "bottom-right",
    title: "Moderate Likelihood",
    titleColor: LIKELIHOOD_LEVELS.MODERATE.color,
    descriptions: ["Small Change from Historic", "Large Confidence Interval"],
  },
];

/**
 * Returns quadrant label configurations for the bubble chart showing likelihood levels in each quadrant.
 */
export const getQuadrantLabelConfigs = (): QuadrantLabel[] => {
  return quadrantLabelOptions;
};
